export interface Config {
    /**
     * 区分海外环境标识
     */
    isIntl: boolean;
}

const config: Config = {
    isIntl: false,
};

export const getConfig = (): Config => ({
    ...config,
});

export const setConfig = (params: Partial<Config>) => {
    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            const typedKey = key as keyof Config;
            config[typedKey] = params[typedKey]!;
        }
    }
};
